export default __webpack_public_path__ + "130406f1755fac8cb975cab4b56b1f05.png";